// components/MenuList.jsx
import React from 'react';
import MenuCard from './MenuCard';

const MenuList = ({ items, onItemClick }) => {
    if (items.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-16 text-center">
                <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                    <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <p className="text-gray-500 text-lg">No items found in this category</p>
                <p className="text-gray-400 text-sm mt-1">Try selecting a different category</p>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {items.map((item, index) => (
                <MenuCard key={item.id || index} item={item} onClick={onItemClick} />
            ))}
        </div>
    );
};

export default MenuList;